import { type FC } from 'react';
import {
  UserGear
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconUserGearProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconUserGear: FC<UiIconUserGearProps> = (props) => {
  return (
    <UiIcon
      IconComponent={UserGear}
      {...props}
    />
  );
};